<template>
  <div>
    <div class="search-table">
      <el-date-picker
          style="width: 115px"
          :clearable="false"
          v-model="monthAndYear"
          type="month"
          @change="handelUpdateDate"
          placeholder="Chọn tháng"
          value-format="M-yyyy"
          format="MM-yyyy"
      />

      <el-select
          @change="handleChangeKidStatus"
          style="width: 120px"
          v-model="dataSearch.kidStatus"
          placeholder="Trạng thái"
      >
        <el-option
            v-for="(item,index) in kidStatusListExcel"
            :key="index"
            :value="item.key"
            :label="item.value"
        />
      </el-select>

      <el-select
          @change="handleChangeKidGrade"
          style="width: 160px"
          v-model="dataSearch.idGrade"
          placeholder="Chọn khối"
      >
        <el-option
            v-for="(item,index) in gradeList"
            :key="index"
            :value="item.id"
            :label="item.gradeName"
        />
      </el-select>

      <el-select
          style="width: 160px"
          v-model="dataSearch.idClass"
          @change="handleChangeKidClass"
          placeholder="Chọn lớp"
      >
        <el-option
            v-for="item in classList"
            :key="item.id"
            :value="item.id"
            :label="item.className"
        />
      </el-select>

      <el-select
          @change="handleChangeStatus"
          @remove-tag="handleChangeStatus"
          @clear="handleChangeStatus"
          style="width: 203px"
          placeholder="Chọn trạng thái"
          v-model="status"
          multiple
          collapse-tags
          clearable
      >
        <el-option
            v-for="(item, index) in statusOrderList"
            :label="item"
            :key="index"
            :value="item"
        />
      </el-select>

      <el-input
          @clear="handleClearKidName"
          clearable
          style="width: 240px"
          placeholder="Nhập tên, biệt danh"
          v-model="kidName"
          @keyup.enter.native="handleChangeKidName"
      >
        <template #append>
          <el-button icon="el-icon-search" @click="handleSearchResultByName" />
        </template>
      </el-input>

      <el-select
          @change="handleChangeCollectionTurn"
          style="width: 100px"
          v-model="dataSearch.collectionTurn"
          placeholder="Đợt thu"
      >
        <el-option
            v-for="item in collectionTurn"
            :key="item"
            :value="item"
            :label="`Đợt ${item}`"
        />
      </el-select>
    </div>

    <div class="table-content row-data" style="margin-top: 12px">
      <el-table
          :empty-text="textTable"
          :data="tableData"
          v-loading="loadingData"
          :element-loading-text="$tableLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255,0)"
          :header-cell-style="tableHeaderColor"
          @selection-change="handleSelectionChange"
          :max-height="$tableMaxHeight"
          border
      >
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <el-table-column type="index" fixed="left" label="STT" width="50" align="center"></el-table-column>

        <el-table-column width="250" fixed="left" label="Họ tên">
          <template v-slot:default="scope">
            <el-tooltip placement="top">
              <div slot="content">Mã học sinh: {{ scope.row.kidCode }}<br>Bố/Mẹ: {{ scope.row.fatherPhone }} - {{ scope.row.motherPhone }}</div>
              <span>{{ scope.row.fullName }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column width="100" label="Biệt danh" align="center">
          <template v-slot:default="scope">
            <span>{{ scope.row.nickName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" width="150" label="Trạng thái">
          <template v-slot:default="scope">
            <div :class="getStatusColor(scope.row.status)">{{ getStatusValue(scope.row.status) }}</div>
          </template>
        </el-table-column>

        <el-table-column align="right" width="150" label="Phải thu tháng này" prop="sumMoney">
          <template v-slot:default="scope">
            {{ scope.row.sumMoney | formatCurrency }}
          </template>
        </el-table-column>

        <el-table-column align="right"  label="Đã thu" prop="collectedMoney">
          <template v-slot:default="scope">
            <el-button
                v-if="getStatusValue(scope.row.status) !== 'Chưa có hóa đơn'"
                class="click-in-row"
                type="text"
            >
              <span v-if="scope.row.collectedMoney">{{ scope.row.collectedMoney | formatCurrency }}</span>
              <span v-else><b>-</b></span>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column align="right"  label="Tiền mặt" prop="cashMoney">
          <template v-slot:default="scope">
            {{ scope.row.cashMoney | formatCurrency }}
          </template>
        </el-table-column>

        <el-table-column align="right"  label="Chuyển khoản" prop="transferMoney">
          <template v-slot:default="scope">
            {{ scope.row.transferMoney | formatCurrency }}
          </template>
        </el-table-column>

        <el-table-column align="right" width="200" label="Thiếu / Thừa còn lại" prop="afterMoney">
          <template v-slot:default="scope">
            {{ scope.row.afterMoney | formatCurrency }}
          </template>
        </el-table-column>

        <el-table-column label="Tác vụ" fixed="right" align="center" width="150">
          <template v-slot:default="scope">
            <div style="display:inline-flex">
              <el-tooltip content="Phiếu thu HP từ Onekids" placement="top">
                <el-button
                    type="primary"
                    size="mini"
                    @click="orderKidsCashierMethod(scope.row)"
                >Tạo HĐ</el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <SelectRevenueByClassDialog
          :isOpenSelectRevenueByClassDialog="isOpenSelectRevenueByClassDialog"
          @dialog-close="closeSelectRevenueByClassDialog"
          :isActivatedAccount="isActivatedAccount"
          ref="OrderKidsExcelCashier"
      />

      <InvoiceCreateManyDialog
          :isOpenInvoiceCreateDialog="isOpenInvoiceCreateManyDialog"
          :kidCodes="selectedKidCodes"
          :invoicePurpose="invoicePurpose"
          @dialog-close="closeInvoiceCreateManyDialog"
      />

    </div>
    <el-row style="margin-top: 15px;">
      <el-col :span="15"  style="display: inline-flex; justify-content: right">
        <el-pagination
            style="margin-right: 5.2rem; margin-left: auto"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPagePagination"
            :page-sizes="listSizeLimit"
            :page-size="sizeLimit"
            layout="prev, pager, sizes, next"
            :total="sizeLimit * totalPages"
        />
      </el-col>
      <el-col :span="9" style="display: inline-flex; justify-content: right">
        <div class="batch-action-menu">
          <el-dropdown trigger="click" @command="handleBatchCommand">
            <el-button type="success" size="medium">
              Tác vụ
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu class="batch-action-dropdown-menu">
                <el-dropdown-item command="createManyDraft"   v-if="checkPermission(['electronic-invoice-create-draft'])">
                  Tạo nhiều HĐ nháp
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from "moment";
import {mapState} from "vuex";
import GradeService from "@/services/GradeService";
import financeKidsV2Service from "@/services/Finance_Kids_V2/FinanceKidsV2Service";
import {kidStatusListExcel} from "@/constant/listCommon";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import checkPermission from "@/utils/permission";
import countColumnActionMixin from "@/global/mixin/countColumnAction.mixin";
import tableValidateMixin from "@/global/mixin/tableValidate.mixin";
import SelectRevenueByClassDialog from "@/components/sinvoice_viettel/dialog/SelectRevenueByClassDialog.vue";
import InvoiceCreateManyDialog from "@/components/sinvoice_viettel/dialog/InvoiceCreateManyDialog.vue";

export default {
  name: "SinvoiceExportByClass",
  components: {
    SelectRevenueByClassDialog,
    InvoiceCreateManyDialog,
  },
  mixins: [countColumnActionMixin, tableValidateMixin],
  computed: {
    ...mapState("finance2Module", [
      "responseFilterList",
      "loadingData",
      "listKT",
      "dataSearch",
      "checkResponse",
      "totalPages",
    ]),
    tableData() {
      if (Array.isArray(this.responseFilterList)) return this.responseFilterList;
      if (this.responseFilterList && Array.isArray(this.responseFilterList.listFilterDTO)) return this.responseFilterList.listFilterDTO;
      if (this.responseFilterList && Array.isArray(this.responseFilterList.list)) return this.responseFilterList.list;
      return [];
    },
  },
  watch: {
    monthAndYear: {
      handler(val) {
        this.dataSearch.month = val.split("-")[0];
        this.dataSearch.createdYear = val.split("-")[1];
      },
    },
    checkResponse() {
      if (this.checkResponse === false) {
        this.textTable = this.$tableEmpty;
      }
    },
  },
  data() {
    return {
      isUpdateCollectionTurn: true,
      monthAndYear: moment().format("M-yyyy"),
      currentPagePagination: 1,
      kidName: "",
      status: [],
      kidStatusListExcel,
      gradeList: [],
      classList: [],
      statusOrderList: [],
      flag: false,
      sizeLimit: 30,
      listSizeLimit: [30, 40, 50, 100],
      collectionTurn: 0,
      textTable: this.$tableEmpty,
      dataSearch: {
        monthAndYear: "",
        collectionTurn: null, // đợt thu
        month: moment().format('M'),
        kidStatus: "STUDYING",
        idGrade: "",
        idClass: "",
        name: "", // tên học sinh
        page: 1,
        limit: 30,
        statusList: [],
        createdYear: moment().format("YYYY"),
      },
      showOrHidden: {
        date: "",
        idKid: "",
        collectionTurn: "",
        status: false,
      },
      kidDetailData: {},
      isOpenKidDetailDialog: false,
      isOpenSelectRevenueByClassDialog: false,
      multipleSelection: [],
      isActivatedAccount: false,
      isOpenInvoiceCreateManyDialog: false,
      selectedKidCodes: [],
      invoicePurpose: "ONEKIDS_ORDER"
    };
  },
  created() {
    this.fetchDataTable();
    this.$store.commit("finance2Module/renew_bill_preview");
    this.dataSearch.monthAndYear = this.monthAndYear;
  },
  methods: {
    checkPermission,
    handelUpdateDate() {
      this.currentPagePagination = 1;
      this.dataSearch.page = 1;
      this.$store.commit("finance2Module/loading_data");
      this.$store.commit("finance2Module/setCheckRevenue");
      this.isUpdateCollectionTurn = true;
      this.dataSearch.monthAndYear = this.monthAndYear;
      this.getStatus();
    },
    handleChangeKidStatus() {
      this.currentPagePagination = 1;
      this.dataSearch.page = 1;
      this.$store.commit("finance2Module/loading_data");
      this.$store.dispatch("finance2Module/init_kids_data", this.dataSearch);
    },
    handleChangeKidGrade() {
      this.$store.commit("finance2Module/loading_data");
      this.currentPagePagination = 1;
      this.dataSearch.page = 1;
      this.isUpdateCollectionTurn = true;
      this.getClassOfGrade();
    },
    handleChangeKidClass() {
      this.$store.commit("finance2Module/loading_data");
      this.currentPagePagination = 1;
      this.dataSearch.page = 1;
      this.isUpdateCollectionTurn = true;
      this.getStatus();
    },
    handleChangeStatus() {
      this.flag = false;
      if (2 <= this.status.length) {
        for (let i = 0; i < this.status.length; i++) {
          if (this.status[i] === "Chưa có hóa đơn") {
            this.flag = true;
            break;
          }
        }
      }
      if (this.flag === false) {
        this.dataSearch.statusList = this.status;
        this.$store.commit("finance2Module/loading_data");
        this.currentPagePagination = 1;
        this.dataSearch.page = 1;
        this.$store.dispatch("finance2Module/init_kids_data", this.dataSearch);
      } else {
        this.$message.error({
          showClose: true,
          message: "Không thể chọn Chưa có hóa đơn cùng với các trạng thái khác. <br>Vui lòng chọn lại!",
          dangerouslyUseHTMLString: true,
        });
      }
    },
    handleChangeKidName() {
      this.$store.commit("finance2Module/loading_data");
      this.currentPagePagination = 1;
      this.dataSearch.page = 1;
      this.dataSearch.name = this.kidName;
      this.$store.dispatch("finance2Module/init_kids_data", this.dataSearch);
    },
    handleSearchResultByName() {
      this.$store.commit("finance2Module/loading_data");
      this.currentPagePagination = 1;
      this.dataSearch.page = 1;
      this.dataSearch.name = this.kidName;
      this.$store.dispatch("finance2Module/init_kids_data", this.dataSearch);
    },
    handleClearKidName() {
      this.$store.commit("finance2Module/loading_data");
      this.dataSearch.page = 1;
      this.currentPagePagination = 1;
      this.dataSearch.name = this.kidName;
      this.$store.dispatch("finance2Module/init_kids_data", this.dataSearch);
    },
    handleChangeCollectionTurn() {
      this.dataSearch.page = 1;
      this.currentPagePagination = 1;
      this.$store.commit("finance2Module/loading_data");
      this.$store.dispatch("finance2Module/init_kids_data", this.dataSearch);
    },
    handleSizeChange(value) {
      this.$store.commit("finance2Module/loading_data");
      this.currentPagePagination = 1;
      this.dataSearch.page = 1;
      this.sizeLimit = value;
      this.dataSearch.limit = value;
      this.$store.dispatch("finance2Module/init_kids_data", this.dataSearch);
    },
    handleCurrentChange(value) {
      this.$store.commit("finance2Module/loading_data");
      this.currentPagePagination = value;
      this.dataSearch.page = value;
      this.$store.dispatch("finance2Module/init_kids_data", this.dataSearch);
    },
    fetchDataTable() {
      this.getAllGrade();
    },
    getAllGrade() {
      this.$store.commit("finance2Module/loading_data");
      GradeService.getGradeInPrinciple()
          .then((resp) => {
            this.gradeList = resp.data.data;
            if (this.gradeList.length > 0) {
              this.dataSearch.idGrade = this.gradeList[0].id;
              this.getClassOfGrade();
            }
          })
          .catch((err) => {
            console.log(err);
            NotifyMessage.leftCornerNotificationError("Lỗi dữ liệu!");
            this.$store.commit("finance2Module/check_response", false);
          });
    },
    getClassOfGrade() {
      financeKidsV2Service
          .getClassInGrade(this.dataSearch.idGrade)
          .then((resp) => {
            this.classList = resp.data && resp.data.data ? resp.data.data : [];
            this.dataSearch.idClass = this.classList.length > 0 ? this.classList[0].id : "";
            this.getStatus();
          })
          .catch((err) => {
            NotifyMessage.leftCornerNotificationError("Lỗi dữ liệu!");
            this.$store.commit("finance2Module/check_response", false);
            console.log(err);
          });
    },
    getCollectionTurn() {
      financeKidsV2Service
          .getCollectionTurn(
              this.dataSearch.month,
              this.dataSearch.idGrade,
              this.dataSearch.idClass,
              this.dataSearch.createdYear
          )
          .then((res) => {
            if (res.data === 0) {
              this.dataSearch.collectionTurn = null;
              this.collectionTurn = null;
              this.$store.commit("finance2Module/loading_data");
              this.$store.dispatch("finance2Module/init_kids_data", this.dataSearch);
              return;
            }
            this.collectionTurn = res.data;
            this.dataSearch.collectionTurn = this.collectionTurn;
            this.$store.commit("finance2Module/loading_data");
            this.$store.dispatch("finance2Module/init_kids_data", this.dataSearch);
          })
          .catch(() => {
            NotifyMessage.leftCornerNotificationError("Lỗi dữ liệu!");
            this.$store.commit("finance2Module/check_response", false);
          });
    },
    getStatus() {
      financeKidsV2Service
          .getListStatusExcel(
              this.dataSearch.month,
              this.dataSearch.idGrade,
              this.dataSearch.idClass,
              this.dataSearch.createdYear
          )
          .then((res) => {
            this.statusOrderList = res.data;
            if (!this.isUpdateCollectionTurn) {
              this.$store.dispatch("finance2Module/init_kids_data", this.dataSearch);
            } else {
              this.getCollectionTurn();
            }
          })
          .catch((error) => {
            NotifyMessage.leftCornerNotificationError("Lỗi dữ liệu!");
            console.log(error);
            this.$store.commit("finance2Module/check_response", false);
          });
    },
    getStatusValue(status) {
      return status !== null ? status : "Chưa có hóa đơn";
    },
    getStatusColor(status) {
      if (status === null) return "status-red";
      if (status === "Chưa đóng 100%" || status === "Chưa đóng đủ") return "status-orange";
      if (status === "Đóng đủ 100%" || status === "Đóng thừa") return "status-blue";
      return "";
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.listNullBillKids = [];
      this.listHiddenOrder = [];
      this.listShowForApp = [];
      this.listHiddenForApp = [];
      this.multipleSelection.forEach((row) => {
        if (this.validateNullBillStudent(row)) {
          this.listNullBillKids = [...this.listNullBillKids, row.fullName];
        }
        if (this.validateHiddenOrder(row)) {
          this.listHiddenOrder = [...this.listHiddenOrder, row.fullName];
        }
        if (row.orderHidden) {
          this.listShowForApp = [...this.listShowForApp, row.fullName];
        }
        if (!row.orderHidden) {
          this.listHiddenForApp = [...this.listHiddenForApp, row.fullName];
        }
      });
      this.$store.commit("finance2Module/set_hidden_order_kids", this.listHiddenOrder);
      this.$store.commit("finance2Module/set_show_for_app", this.listShowForApp);
      this.$store.commit("finance2Module/set_hidden_for_app", this.listHiddenForApp);
      this.$store.commit("finance2Module/set_null_bill_kids", this.listNullBillKids);
      let idKidList = [];
      this.multipleSelection.forEach((item) => {
        idKidList = [...idKidList, item.id];
      });
      this.$store.commit("finance2Module/set_id_kid_list", idKidList);
    },

    orderKidsCashierMethod(row) {
      if (this.dataSearch.collectionTurn === 0) {
        this.$message({ message: "Bạn chưa chọn đợt thu", type: "error" });
      } else {
        const idKid = row.id;
        const kidCode = row.kidCode;
        const kidName = row.fullName;
        const orderKidCode = row.orderKidCode;
        const month = this.dataSearch.month;
        const year = this.dataSearch.createdYear;
        const collectionTurn = this.dataSearch.collectionTurn;
        this.isOpenSelectRevenueByClassDialog = true;
        this.$refs.OrderKidsExcelCashier.getDataCashierInitial(
            idKid,
            kidCode,
            kidName,
            month,
            collectionTurn,
            orderKidCode,
            year
        );
        this.isActivatedAccount = row.fatherPhone !== "" || row.motherPhone !== "";
      }
    },

    closeSelectRevenueByClassDialog() {
      this.isOpenSelectRevenueByClassDialog = false;
      this.$store.commit("finance2Module/get_status_excel");
    },

    handleBatchCommand(command) {
      if (command === 'createManyDraft') {
        this.openInvoiceCreateManyDialog();
      }
    },
    openInvoiceCreateManyDialog() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message({ message: 'Vui lòng chọn ít nhất một học sinh', type: 'warning' });
        return;
      }
      this.selectedKidCodes = this.multipleSelection.map(row => row.kidCode).filter(Boolean);
      if (this.selectedKidCodes.length === 0) {
        this.$message({ message: 'Không tìm thấy mã học sinh trong danh sách đã chọn', type: 'error' });
        return;
      }
      this.isOpenInvoiceCreateManyDialog = true;
    },
    closeInvoiceCreateManyDialog() {
      this.isOpenInvoiceCreateManyDialog = false;
    },
    tableHeaderColor(column) {
      this.countNonEmptyAttributes(this.listKT);
      if (14 < column.columnIndex && column.columnIndex <= 14 + this.countColumnAttributes) {
        return "background-color: #ea580cb3;color: #fff;font-weight: light;";
      }
      return "background-color: #78a5e7;color: #fff;font-weight: light;";
    },
  },
};
</script>

<style scoped lang="scss">
.search-table { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 12px; }
.status-red { color: red; }
.status-orange { color: orange; }
.status-blue { color: blue; }
</style>

